
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.8 19.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.7 1.4h-2.3V.5c0-.3-.2-.5-.4-.5-.3 0-.5.2-.5.5v.9h-1.6V.5c.1-.3-.2-.5-.4-.5-.3 0-.5.2-.5.5v.9H6.4V.5c0-.3-.2-.5-.5-.5-.2 0-.4.2-.4.5v.9H3.9V.5c0-.3-.2-.5-.4-.5-.3 0-.5.2-.5.5v.9H1c-.6 0-1 .5-1 1v15.7c0 .6.5 1 1 1h13.6l3.1-2.8V2.4c0-.5-.4-1-1-1zM1.1 7.2h15.5v8.6h-2.2c-.3 0-.5.2-.5.5V18H1.1V7.2z","fill":"#4e5d6b"}})])
          )
        }
      }
    